module.exports = __webpack_public_path__ + "static/media/PDF_114.c6e40fe2.pdf";